














import { defineComponent } from '@vue/composition-api';
import HelpMenu from './HelpMenu.vue';
import ReportIssuesMenu from './ReportIssuesMenu.vue';
import { helpDialog, reportIssuesDialog } from '../state';

export default defineComponent({
  name: 'About',
  components: { HelpMenu, ReportIssuesMenu },
  setup() {
    return { helpDialog, reportIssuesDialog };
  },
});
